import { ReportHandler } from 'web-vitals';

import runningOnProd from './runningOnProd';

// TODO: are we using this?
const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (!runningOnProd()) return;

  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
